var m = require('mithril');
var Point = require('../../../../../models/data/point');
var ontologyFields = require('../../../../../models/equipment/ontologyFields');

function formatQuantityDisplayValue(quantity) {
  if (!quantity || !ontologyFields.quantityValueHasContent(quantity)) return '';
  if (!quantity.unit) return String(quantity.value);

  var formatted = Point.readValue({
    value: quantity.value,
    unit: quantity.unit,
    destUnit: quantity.unit
  });
  return formatted === '---' ? String(quantity.value) : formatted;
}

function formatQuantityUnit(unit) {
  if (!unit) return '';
  return Point.formatUnit({ displayUnit: unit }) || unit;
}

function getQuantityParts(record, field) {
  var normalized = ontologyFields.normalizeFieldDefinition(field);
  if (!normalized || !ontologyFields.isQuantityField(normalized)) return null;

  var resolved = ontologyFields.readEquipmentFieldValue(record, normalized);
  var quantity = ontologyFields.normalizeQuantityValue(resolved.value, normalized.defaultUnit);
  if (!quantity || !ontologyFields.quantityValueHasContent(quantity)) return null;

  return {
    value: formatQuantityDisplayValue(quantity),
    unit: formatQuantityUnit(quantity.unit)
  };
}

function render(record, field, options) {
  var emptyText = options && typeof options.emptyText !== 'undefined' ? options.emptyText : '';
  var quantityParts = getQuantityParts(record, field);
  if (quantityParts) {
    return [
      m('span', quantityParts.value),
      quantityParts.unit ?
        m('span.v-top.dib.moon-gray.ml1', { style: { fontSize: '10px' } }, quantityParts.unit)
      :
        ''
    ];
  }

  return ontologyFields.getDisplayFieldValue(record, field) || emptyText;
}

module.exports = {
  formatQuantityDisplayValue: formatQuantityDisplayValue,
  formatQuantityUnit: formatQuantityUnit,
  getQuantityParts: getQuantityParts,
  render: render
};
